// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * ALMA Chatbot API
 * API to manage Alma chatbot interactions.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { MainUrlWithScore } from './MainUrlWithScore';
import {
  MainUrlWithScoreFromJSON,
  MainUrlWithScoreFromJSONTyped,
  MainUrlWithScoreToJSON,
  MainUrlWithScoreToJSONTyped,
} from './MainUrlWithScore';

/**
 *
 * @export
 * @interface MainAskResponse
 */
export interface MainAskResponse {
  /**
   *
   * @type {string}
   * @memberof MainAskResponse
   */
  answer?: string;
  /**
   *
   * @type {Array<MainUrlWithScore>}
   * @memberof MainAskResponse
   */
  contextUrls?: Array<MainUrlWithScore>;
  /**
   *
   * @type {number}
   * @memberof MainAskResponse
   */
  conversationId?: number;
  /**
   *
   * @type {Array<MainUrlWithScore>}
   * @memberof MainAskResponse
   */
  references?: Array<MainUrlWithScore>;
}

/**
 * Check if a given object implements the MainAskResponse interface.
 */
export function instanceOfMainAskResponse(
  value: object,
): value is MainAskResponse {
  return true;
}

export function MainAskResponseFromJSON(json: any): MainAskResponse {
  return MainAskResponseFromJSONTyped(json, false);
}

export function MainAskResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): MainAskResponse {
  if (json == null) {
    return json;
  }
  return {
    answer: json['answer'] == null ? undefined : json['answer'],
    contextUrls:
      json['context_urls'] == null
        ? undefined
        : (json['context_urls'] as Array<any>).map(MainUrlWithScoreFromJSON),
    conversationId:
      json['conversation_id'] == null ? undefined : json['conversation_id'],
    references:
      json['references'] == null
        ? undefined
        : (json['references'] as Array<any>).map(MainUrlWithScoreFromJSON),
  };
}

export function MainAskResponseToJSON(json: any): MainAskResponse {
  return MainAskResponseToJSONTyped(json, false);
}

export function MainAskResponseToJSONTyped(
  value?: MainAskResponse | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    answer: value['answer'],
    context_urls:
      value['contextUrls'] == null
        ? undefined
        : (value['contextUrls'] as Array<any>).map(MainUrlWithScoreToJSON),
    conversation_id: value['conversationId'],
    references:
      value['references'] == null
        ? undefined
        : (value['references'] as Array<any>).map(MainUrlWithScoreToJSON),
  };
}
